<router-outlet />
<z-loader />
<z-toaster />
@if (!isStandAlonePortal()) {
  <app-auth-data-sitter-dialog
    [isDialogVisible]="showAuthDataSitterDialog()"
    (isDialogVisibleChange)="showAuthDataSitterDialog.set($event)"
  />
}
